/* tslint:disable */
/* eslint-disable */
export enum WorkVoucherSourceEnum {
  Capture = 'capture',
  LegacyCreditor = 'legacy_creditor'
}
